/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Link, useHistory, useLocation } from 'react-router-dom';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import VerticalForm from '../../components/VerticalForm';
import FormInput from '../../components/FormInput';
import { AccountContext } from '../../contexts/Accounts';
import Texts from '../../data/texts';
import { CognitoErrors } from '../../core/config/Constants';
import AccountLayout from '../../layouts/Authentication/AccountLayout';

const Login = () => {
  const history = useHistory();
  const location = useLocation();
  const { authenticate, resendConfirmationCode, checkEmailAvailability } =
    useContext(AccountContext);
  const [submitError, setSubmitError] = useState();
  const [loading, setLoading] = useState(false);
  const [redirectTo, setRedirectTo] = useState('');
  const companyPortalURL = 'https://company.go-turtle.com/login';

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search.replace('?', ''));
    const email = urlParams.get('email') || '';
    if (email.trim() !== '') {
      // eslint-disable-next-line no-unused-vars
      const decodedEmail = decodeURIComponent(email);
      // formik.setFieldValue('email', decodedEmail);
      checkEmailAvailability(decodedEmail)
        .then((result) => console.log(result))
        .catch((error) => console.log(error));
    }
    const redirect = urlParams.get('redirect') || '';
    if (redirect.trim() !== '') {
      const decodedRedirect = decodeURIComponent(redirect);
      setRedirectTo(decodedRedirect);
    }
  }, []);

  const schemaResolver = yupResolver(
    Yup.object().shape({
      username: Yup.string()
        .email('Please enter valid Email')
        .required('Please enter Email'),
      password: Yup.string().required('Please enter Password')
    })
  );

  const onSubmit = (values) => {
    setSubmitError('');
    setLoading(true);
    authenticate(values.username.toLowerCase(), values.password)
      .then((data) => {
        const urlParams = new URLSearchParams(location.search.replace('?', ''));
        const from = urlParams.get('from');
        if (data.newPasswordRequired) {
          history.push(`new-password?from=${from}`, {
            requiredAttributes: data.requiredAttributes
          });
        } else {
          if (redirectTo.trim() !== '') {
            history.push(redirectTo);
          } else {
            history.push('/');
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err && err.code === CognitoErrors.USER_NOT_AUTHORIZED) {
          setSubmitError(Texts.LOGIN.WRONG_CREDENTIALS);
        } else if (err && err.code === CognitoErrors.USER_NOT_CONFIRMED) {
          setSubmitError(Texts.LOGIN.ACCOUNT_NOT_CONFIRMED);
          resendConfirmationCode(values.username.toLowerCase());
        } else if (
          err &&
          err.code === CognitoErrors.INVALID_USER_PASSWORD_REQUIRED_CHANGE
        ) {
          history.push('/reset-password-request');
        } else {
          setSubmitError(Texts.LOGIN.WRONG_CREDENTIALS);
        }
      });
  };

  const BottomLink = () => {
    return (
      <>
        <Row className="mt-3">
          <Col className="text-center">
            <p className="text-muted">
              Don't have an account?{' '}
              <Link to={{ pathname: '/sign-up' }} className="text-info ms-1">
                <b>Register</b>
              </Link>
            </p>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col className="text-center">
            <p className="text-muted">
              <b>
                <a
                  data-cy="login-as-company"
                  href={companyPortalURL}
                  className="text-info ms-1"
                >
                  Login
                </a>
              </b>{' '}
              as a Company
            </p>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <AccountLayout bottomLinks={<BottomLink />}>
      <div className="text-start w-100 mx-auto">
        <h1 className="display-1 text-primary text-start mt-0 fw-bold">Sign In</h1>
        <p className="text-muted text-start mb-4">Sign in to the Seafarer portal</p>
      </div>

      {submitError && (
        <Alert variant="danger" className="my-2">
          {submitError}
        </Alert>
      )}

      <VerticalForm onSubmit={onSubmit} resolver={schemaResolver}>
        <FormInput
          label="Email address"
          type="text"
          name="username"
          placeholder="Enter your email"
          containerClass="mb-3"
        />
        <FormInput
          label="Password"
          type="password"
          name="password"
          placeholder="Enter your password"
          containerClass="mb-3"
        >
          <Link to="/forgot-password" className="text-muted float-end">
            <small>Forgot your password?</small>
          </Link>
        </FormInput>

        <div className="mb-3 mb-0 text-center">
          <Button
            className="w-100"
            variant="danger"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <i className="fa fa-circle-o-notch fa-spin fa-lg fa-fw" />
            ) : (
              'Log In'
            )}
          </Button>
        </div>
      </VerticalForm>
    </AccountLayout>
  );
};

export default Login;
